import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useIntl } from 'react-intl';
import Box from '@mui/material/Box';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import StravaActivitySelect from '../comparison/StravaActivitySelect';
import { StravaActivity } from '../../services/StravaService';

interface TrainingRunStepStravaSelectProps {
  activities: StravaActivity[];
  isLoading: boolean;
  selectedDate: dayjs.Dayjs | null;
  selectedActivityId: number | null;
  onDateChange: (date: dayjs.Dayjs | null) => void;
  onSelectActivity: (activityId: number) => void;
  error: string | null;
}

const TrainingRunStepStravaSelect: React.FC<TrainingRunStepStravaSelectProps> = observer(({
  activities,
  isLoading,
  selectedDate,
  selectedActivityId,
  onDateChange,
  onSelectActivity,
  error
}) => {
  const intl = useIntl();

  return (
    <Box sx={{ mt: 3 }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label={intl.formatMessage({ id: 'trainingRun.selectDate' })}
          value={selectedDate}
          onChange={onDateChange}
          sx={{ mb: 3, width: '100%' }}
        />
      </LocalizationProvider>

      <StravaActivitySelect
        activities={activities}
        isLoading={isLoading}
        selectedActivityId={selectedActivityId}
        onSelectActivity={onSelectActivity}
        date={selectedDate?.toDate()}
        error={error}
        description={intl.formatMessage({ id: 'trainingRun.selectActivityDescription' })}
      />
    </Box>
  );
});

export default TrainingRunStepStravaSelect;
